import { render, staticRenderFns } from "./ImageSerializer.vue?vue&type=template&id=5f94dbd0&"
import script from "./ImageSerializer.vue?vue&type=script&lang=js&"
export * from "./ImageSerializer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports